import React from 'react'
import { colors, fontFamily, fontSize, eyebrow as eyebrowStyle, tracking } from '../../styles/theme'

interface PageHeaderProps {
  eyebrow?: React.ReactNode
  title: React.ReactNode
  subtitle?: React.ReactNode
  actions?: React.ReactNode
  style?: React.CSSProperties
}

export function PageHeader({ eyebrow, title, subtitle, actions, style }: PageHeaderProps) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: 16,
      marginBottom: 24,
      ...style,
    }}>
      <div>
        {eyebrow && (
          <div style={{ ...eyebrowStyle, marginBottom: 4 }}>
            {eyebrow}
          </div>
        )}
        <h1 style={{
          margin: 0,
          fontSize: fontSize['2xl'],
          fontWeight: 600,
          color: colors.text,
          letterSpacing: tracking.tight,
          lineHeight: 1.2,
        }}>
          {title}
        </h1>
        {subtitle && (
          <p style={{
            margin: '4px 0 0',
            fontSize: fontSize.sm,
            color: colors.textSecondary,
            lineHeight: 1.5,
          }}>
            {subtitle}
          </p>
        )}
      </div>
      {actions && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0, paddingTop: eyebrow ? 20 : 0 }}>
          {actions}
        </div>
      )}
    </div>
  )
}

export function Eyebrow({ children, style }: { children: React.ReactNode; style?: React.CSSProperties }) {
  return (
    <div style={{ ...eyebrowStyle, ...style }}>
      {children}
    </div>
  )
}
